// src/utils/signatures.js
const signatures = {
    "akedanai@neonworks.co.th":
      "https://res.cloudinary.com/dflnrw7va/image/upload/v1744861377/signatures/h3mg2u5sk1ktdectj95m.png",
    "natorn@neonworks.co.th":
      "https://res.cloudinary.com/dflnrw7va/image/upload/v1744861377/signatures/h3mg2u5sk1ktdectj95m.png",
    "chawachai@optx.co.th":
      "https://res.cloudinary.com/dflnrw7va/image/upload/v1744862831/signatures/o4hejus1csvir7opjuak.png",
  };
  
  export default signatures;
  